import { Input } from '@angular/core'
import { Component } from '@angular/core'
import { faTable } from '@fortawesome/free-solid-svg-icons'
import { Grid } from '../../utility/grid'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    selector: 'action-toolbar-count',
    templateUrl: './action-toolbar-count.component.html',
    standalone: true,
    imports: [FaIconComponent],
})
export class ActionToolbarCount {
    faTable = faTable
    @Input() grid!: Grid<any>
}
